import {useLocalStorage} from 'usehooks-ts'
import {USER_ACCOUNTS_KEY} from '@constant/key'
import {ILoginInfoData, useLoginStore} from '@store/LoginStore'
import {useEffect} from 'react'

export default function useAccounts() {
    const {id: loginId, login, logout} = useLoginStore(state => state)

    const [accounts, setAccounts] = useLocalStorage<ILoginInfoData[]>(USER_ACCOUNTS_KEY, [])

    useEffect(() => {
        const stored = localStorage?.getItem(USER_ACCOUNTS_KEY)
        const arr = JSON.parse(stored)
        if (arr && arr?.length > 0) {
            setAccounts(arr)
        }
    }, [loginId])

    const removeStorage = () => {
        localStorage.removeItem(USER_ACCOUNTS_KEY)
    }

    return {accounts, setAccounts, login, logout, removeStorage}
}
